import React, { forwardRef, RefObject } from 'react';
import classNames from 'classnames';

import { StyledComboboxContentHeader } from './styles';
import { ComboboxContentHeaderProps } from './types';
import { Comp, getContainerStylingTransientProps } from '@redsift/design-system';

const COMPONENT_NAME = 'ComboboxContentHeader';
const CLASSNAME = 'redsift-combobox-content-header';

/**
 * The ComboboxContentHeader component.
 */
export const ComboboxContentHeader: Comp<ComboboxContentHeaderProps, HTMLDivElement> = forwardRef((props, ref) => {
  const { transientProps, otherProps } = getContainerStylingTransientProps(props);

  const { children, className, ...forwardedProps } = otherProps;

  return (
    <StyledComboboxContentHeader
      {...forwardedProps}
      {...transientProps}
      className={classNames(ComboboxContentHeader.className, className)}
      ref={ref as RefObject<HTMLDivElement>}
    >
      {children}
    </StyledComboboxContentHeader>
  );
});
ComboboxContentHeader.className = CLASSNAME;
ComboboxContentHeader.displayName = COMPONENT_NAME;
